// 价格含有区间价/一口价/阶梯价
import React from 'react';

import Product from './product';
import Sample from './sample';
import Semi from './semi';

import './index.less';

interface PropTypes {
  price: PriceTypes.Root;
  i18n: DetailTypes.i18n;
  moq: number;
  type: string;
  productId: number;
  semiHosted: boolean;
  newBuyerActivityText?: string;
  sampleInfo: PriceTypes.Sample;
  indexSelected: number;
  priceListWithLadderLogistic: PriceTypes.PriceListWithLadderLogistic;
  quantityList: PriceTypes.QuantityListItem[];
  defaultLogisticsList: PriceTypes.ShippingType[];
  logisticsRequestIdList: PriceTypes.logisticsRequestIdItem[];
  logisticsSelected: PriceTypes.ShippingType;
  recommendSaveTextMap: PriceTypes.RecommendSaveTextMap;
}

function ProductPrice(props: PropTypes & PriceTypes.Countdown) {
  const { price, sampleInfo, type = 'product', priceListWithLadderLogistic = [], i18n } = props;
  if (!price) return null;
  // 样品价格
  if (type === 'sample') {
    return <Sample sampleInfo={sampleInfo} price={price} i18n={i18n} />;
  }
  // 新版本半托管
  if (priceListWithLadderLogistic.length > 0) {
    return <Semi {...props} />;
  }

  return <Product {...props} />;
}

export default ProductPrice;
